module.exports = __webpack_public_path__ + "assets/media/purple-arrow.c33c6109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookTargetingStep/purple-arrow.svg
// module id = 3143
// module chunks = 0